import script from "./UserInfoForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserInfoForm.vue?vue&type=script&setup=true&lang=ts"

import "./UserInfoForm.vue?vue&type=style&index=0&id=2e2eddef&scoped=true&lang=css"

import exportComponent from "C:\\atto\\atto-chempanda\\chempanda\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e2eddef"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QInput});
